var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0-9.5a3.467,3.467,0,0,0-.976.156A1.731,1.731,0,0,1-.75-8.5,1.751,1.751,0,0,1-2.5-6.75a1.731,1.731,0,0,1-.844-.226,3.488,3.488,0,0,0-.136.968A3.493,3.493,0,0,0,.011-2.518,3.493,3.493,0,0,0,3.5-6.009,3.493,3.493,0,0,0,.011-9.5ZM8.891-6.456A10.023,10.023,0,0,0,0-12,10.024,10.024,0,0,0-8.891-6.456,1.006,1.006,0,0,0-9-6a1.014,1.014,0,0,0,.108.457A10.023,10.023,0,0,0,0,0,10.024,10.024,0,0,0,8.891-5.544,1.006,1.006,0,0,0,9-6,1.014,1.014,0,0,0,8.891-6.456ZM0-1.5A8.5,8.5,0,0,1-7.435-6,8.5,8.5,0,0,1,0-10.5,8.5,8.5,0,0,1,7.435-6,8.5,8.5,0,0,1,0-1.5Z",
    transform: "translate(12 18)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.7c97588a.svg";
export { ForwardRef as ReactComponent };